const Individuals = [
  'https://w3id.org/rec/building/Atrium',
  'https://w3id.org/rec/building/Auditorium',
  'https://w3id.org/rec/building/BackOffice',
  'https://w3id.org/rec/building/BankVault',
  'https://w3id.org/rec/building/BarRoom',
  'https://w3id.org/rec/building/Bathroom',
  'https://w3id.org/rec/building/Bedroom',
  'https://w3id.org/rec/building/BicycleGarage',
  'https://w3id.org/rec/building/Cabinet',
  'https://w3id.org/rec/building/Cinema',
  'https://w3id.org/rec/building/Classroom',
  'https://w3id.org/rec/building/CleaningRoom',
  'https://w3id.org/rec/building/ClimateControlRoom',
  'https://w3id.org/rec/building/CloakRoom',
  'https://w3id.org/rec/building/CoffeeRoom',
  'https://w3id.org/rec/building/ConferenceRoom',
  'https://w3id.org/rec/building/ConversationRoom',
  'https://w3id.org/rec/building/CookingRoom',
  'https://w3id.org/rec/building/CopyingRoom',
  'https://w3id.org/rec/building/DataServerRoom',
  'https://w3id.org/rec/building/DeliRoom',
  'https://w3id.org/rec/building/DiningRoom',
  'https://w3id.org/rec/building/DisabledToilet',
  'https://w3id.org/rec/building/DishingRoom',
  'https://w3id.org/rec/building/DressingRoom',
  'https://w3id.org/rec/building/EducationalRoom',
  'https://w3id.org/rec/building/ElectricityRoom',
  'https://w3id.org/rec/building/ElevatorRoom',
  'https://w3id.org/rec/building/ElevatorShaft',
  'https://w3id.org/rec/building/Entrance',
  'https://w3id.org/rec/building/ExerciseRoom',
  'https://w3id.org/rec/building/ExhibitionRoom',
  'https://w3id.org/rec/building/FittingRoom',
  'https://w3id.org/rec/building/FoodHandlingRoom',
  'https://w3id.org/rec/building/FoodStorageFreezerRoom',
  'https://w3id.org/rec/building/FoodStorageRefrigeratorRoom',
  'https://w3id.org/rec/building/FoodStorageRoom',
  'https://w3id.org/rec/building/Garage',
  'https://w3id.org/rec/building/GroupRoom',
  'https://w3id.org/rec/building/Hallway',
  'https://w3id.org/rec/building/Laboratory',
  'https://w3id.org/rec/building/LaboratoryDry',
  'https://w3id.org/rec/building/LaboratoryWet',
  'https://w3id.org/rec/building/LaundryRoom',
  'https://w3id.org/rec/building/Library',
  'https://w3id.org/rec/building/LivingRoom',
  'https://w3id.org/rec/building/MainEntrance',
  'https://w3id.org/rec/building/Office',
  'https://w3id.org/rec/building/OfficeLandscape',
  'https://w3id.org/rec/building/OfficeRoom',
  'https://w3id.org/rec/building/ParkingSlotCold',
  'https://w3id.org/rec/building/ParkingSlotWarm',
  'https://w3id.org/rec/building/Pentry',
  'https://w3id.org/rec/building/PersonalHygiene',
  'https://w3id.org/rec/building/PhoneBooth',
  'https://w3id.org/rec/building/Reception',
  'https://w3id.org/rec/building/RecordingRoom',
  'https://w3id.org/rec/building/RecreationalRoom',
  'https://w3id.org/rec/building/RestingRoom',
  'https://w3id.org/rec/building/RetailRoom',
  'https://w3id.org/rec/building/Sauna',
  'https://w3id.org/rec/building/ServiceEntrance',
  'https://w3id.org/rec/building/ServiceShaft',
  'https://w3id.org/rec/building/Shelter',
  'https://w3id.org/rec/building/ShelterGasLock',
  'https://w3id.org/rec/building/ShelterRoom',
  'https://w3id.org/rec/building/ShowerRoom',
  'https://w3id.org/rec/building/SmallStudyRoom',
  'https://w3id.org/rec/building/StaffRoom',
  'https://w3id.org/rec/building/Stairwell',
  'https://w3id.org/rec/building/Storage',
  'https://w3id.org/rec/building/StudyRoom',
  'https://w3id.org/rec/building/TelecommunicationRoom',
  'https://w3id.org/rec/building/Theater',
  'https://w3id.org/rec/building/Toilet',
  'https://w3id.org/rec/building/TreatmentRoom',
  'https://w3id.org/rec/building/TreatmentWaitingRoom',
  'https://w3id.org/rec/building/UtilitiesRoom',
  'https://w3id.org/rec/building/Vault',
  'https://w3id.org/rec/building/WasteManagementRoom',
  'https://w3id.org/rec/building/Workshop',
  'https://w3id.org/rec/core/ActiveEnergyL1',
  'https://w3id.org/rec/core/ActiveEnergyL2',
  'https://w3id.org/rec/core/ActiveEnergyL3',
  'https://w3id.org/rec/core/ActiveEnergyTotal',
  'https://w3id.org/rec/core/ActivePowerL1',
  'https://w3id.org/rec/core/ActivePowerL2',
  'https://w3id.org/rec/core/ActivePowerL3',
  'https://w3id.org/rec/core/ActivePowerTotal',
  'https://w3id.org/rec/core/AgentInteraction',
  'https://w3id.org/rec/core/AlarmMajor',
  'https://w3id.org/rec/core/AlarmMinor',
  'https://w3id.org/rec/core/AlarmSevere',
  'https://w3id.org/rec/core/Ampere',
  'https://w3id.org/rec/core/Angle',
  'https://w3id.org/rec/core/Area',
  'https://w3id.org/rec/core/AreaPresence',
  'https://w3id.org/rec/core/Binary',
  'https://w3id.org/rec/core/BooleanDetection',
  'https://w3id.org/rec/core/Celsius',
  'https://w3id.org/rec/core/CO2',
  'https://w3id.org/rec/core/CO',
  'https://w3id.org/rec/core/CoffeePremises',
  'https://w3id.org/rec/core/Concentration',
  'https://w3id.org/rec/core/CosPhi',
  'https://w3id.org/rec/core/CubicMeter',
  'https://w3id.org/rec/core/Current',
  'https://w3id.org/rec/core/CurrentL1',
  'https://w3id.org/rec/core/CurrentL2',
  'https://w3id.org/rec/core/CurrentL3',
  'https://w3id.org/rec/core/Decibel',
  'https://w3id.org/rec/core/Degrees',
  'https://w3id.org/rec/core/EducationalPremises',
  'https://w3id.org/rec/core/Efficiency',
  'https://w3id.org/rec/core/EnergyTotal',
  'https://w3id.org/rec/core/Fahrenheit',
  'https://w3id.org/rec/core/Flow',
  'https://w3id.org/rec/core/Footfall',
  'https://w3id.org/rec/core/GaragePremises',
  'https://w3id.org/rec/core/GlobalIrradiance',
  'https://w3id.org/rec/core/Hertz',
  'https://w3id.org/rec/core/HotelPremises',
  'https://w3id.org/rec/core/Humidity',
  'https://w3id.org/rec/core/Illuminance',
  'https://w3id.org/rec/core/Integer',
  'https://w3id.org/rec/core/Kelvin',
  'https://w3id.org/rec/core/Kilogram',
  'https://w3id.org/rec/core/LaboratoryPremises',
  'https://w3id.org/rec/core/Lenght',
  'https://w3id.org/rec/core/Length',
  'https://w3id.org/rec/core/Level',
  'https://w3id.org/rec/core/LightIndustryPremises',
  'https://w3id.org/rec/core/LiterPerSecond',
  'https://w3id.org/rec/core/Lumen',
  'https://w3id.org/rec/core/Lux',
  'https://w3id.org/rec/core/Meter',
  'https://w3id.org/rec/core/MeterPerSecond',
  'https://w3id.org/rec/core/MillimeterPerHour',
  'https://w3id.org/rec/core/Number',
  'https://w3id.org/rec/core/NumPeople',
  'https://w3id.org/rec/core/OfficePremises',
  'https://w3id.org/rec/core/PartsPerBillion',
  'https://w3id.org/rec/core/PartsPerMillion',
  'https://w3id.org/rec/core/Pascal',
  'https://w3id.org/rec/core/Percentage',
  'https://w3id.org/rec/core/PowerFactor',
  'https://w3id.org/rec/core/PowerFactorL1',
  'https://w3id.org/rec/core/PowerFactorL2',
  'https://w3id.org/rec/core/PowerFactorL3',
  'https://w3id.org/rec/core/PowerFrequency',
  'https://w3id.org/rec/core/Precipation',
  'https://w3id.org/rec/core/Precipitation',
  'https://w3id.org/rec/core/Presence',
  'https://w3id.org/rec/core/Pressure',
  'https://w3id.org/rec/core/Radiation',
  'https://w3id.org/rec/core/ReactivePowerL1',
  'https://w3id.org/rec/core/ReactivePowerL2',
  'https://w3id.org/rec/core/ReactivePowerL3',
  'https://w3id.org/rec/core/ReactivePowerTotal',
  'https://w3id.org/rec/core/RelativeHumidity',
  'https://w3id.org/rec/core/ResidentialPremises',
  'https://w3id.org/rec/core/RestaurantPremises',
  'https://w3id.org/rec/core/RetailPremises',
  'https://w3id.org/rec/core/RevolutionsPerMinute',
  'https://w3id.org/rec/core/RotationSpeed',
  'https://w3id.org/rec/core/Second',
  'https://w3id.org/rec/core/Sound',
  'https://w3id.org/rec/core/Speed',
  'https://w3id.org/rec/core/SquareMeter',
  'https://w3id.org/rec/core/StoragePremises',
  'https://w3id.org/rec/core/SunshineTimePerHour',
  'https://w3id.org/rec/core/Temperature',
  'https://w3id.org/rec/core/TVOC',
  'https://w3id.org/rec/core/Velocity',
  'https://w3id.org/rec/core/Volt',
  'https://w3id.org/rec/core/Voltage',
  'https://w3id.org/rec/core/VoltageL1',
  'https://w3id.org/rec/core/VoltageL2',
  'https://w3id.org/rec/core/VoltageL3',
  'https://w3id.org/rec/core/Volume',
  'https://w3id.org/rec/core/WasteDiverted',
  'https://w3id.org/rec/core/WasteTotal',
  'https://w3id.org/rec/core/Watt',
  'https://w3id.org/rec/core/WattHour',
  'https://w3id.org/rec/core/WattPerSquareMeter',
  'https://w3id.org/rec/device/1.yyy',
  'https://w3id.org/rec/device/15',
  'https://w3id.org/rec/device/16',
  'https://w3id.org/rec/device/1',
  'https://w3id.org/rec/device/1_byte',
  'https://w3id.org/rec/device/2',
  'https://w3id.org/rec/device/2_byte',
  'https://w3id.org/rec/device/2_byte_BCD',
  'https://w3id.org/rec/device/2_byte_signed_integer',
  'https://w3id.org/rec/device/2_byte_signed_integer_swapped',
  'https://w3id.org/rec/device/2_byte_unsigned_integer',
  'https://w3id.org/rec/device/2_byte_unsigned_integer_swapped',
  'https://w3id.org/rec/device/3',
  'https://w3id.org/rec/device/4',
  'https://w3id.org/rec/device/4_byte_BCD',
  'https://w3id.org/rec/device/4_byte_BCD_swapped',
  'https://w3id.org/rec/device/4_byte_float',
  'https://w3id.org/rec/device/4_byte_float_BCD',
  'https://w3id.org/rec/device/4_byte_float_swapped',
  'https://w3id.org/rec/device/4_byte_signed_integer',
  'https://w3id.org/rec/device/4_byte_signed_integer_swapped',
  'https://w3id.org/rec/device/4_byte_signed_integer_swapped_bytes_and_words',
  'https://w3id.org/rec/device/4_byte_unsigned_integer',
  'https://w3id.org/rec/device/4_byte_unsigned_integer_swapped',
  'https://w3id.org/rec/device/4_byte_unsigned_integer_swapped_bytes_and_words',
  'https://w3id.org/rec/device/5',
  'https://w3id.org/rec/device/6',
  'https://w3id.org/rec/device/8_byte_float',
  'https://w3id.org/rec/device/8_byte_float_swapped',
  'https://w3id.org/rec/device/8_byte_signed_integer',
  'https://w3id.org/rec/device/8_byte_signed_integer_swapped',
  'https://w3id.org/rec/device/8_byte_unsigned_integer',
  'https://w3id.org/rec/device/8_byte_unsigned_integer_swapped',
  'https://w3id.org/rec/device/AirDiffuser',
  'https://w3id.org/rec/device/AirHandlingUnit',
  'https://w3id.org/rec/device/BACnet',
  'https://w3id.org/rec/device/Battery',
  'https://w3id.org/rec/device/Boiler',
  'https://w3id.org/rec/device/Chiller',
  'https://w3id.org/rec/device/CirculationAir',
  'https://w3id.org/rec/device/Coil',
  'https://w3id.org/rec/device/ColdWaterFlow',
  'https://w3id.org/rec/device/ColdWaterReturn',
  'https://w3id.org/rec/device/CommunicationBusPowerSource',
  'https://w3id.org/rec/device/Compressor',
  'https://w3id.org/rec/device/Condenser',
  'https://w3id.org/rec/device/Control',
  'https://w3id.org/rec/device/Damper',
  'https://w3id.org/rec/device/DataAcquisition',
  'https://w3id.org/rec/device/DataCommunicationGateway',
  'https://w3id.org/rec/device/DirectionInward',
  'https://w3id.org/rec/device/DirectionOutward',
  'https://w3id.org/rec/device/DistrictCoolingFlow',
  'https://w3id.org/rec/device/DistrictCoolingReturn',
  'https://w3id.org/rec/device/DistrictHeatingFlow',
  'https://w3id.org/rec/device/DistrictHeatingReturn',
  'https://w3id.org/rec/device/ElectricalGridEV',
  'https://w3id.org/rec/device/ElectricalGridIntake',
  'https://w3id.org/rec/device/ElectricalGridInternal',
  'https://w3id.org/rec/device/ElectricalGridLocalProduction',
  'https://w3id.org/rec/device/ElectricalGridTenant',
  'https://w3id.org/rec/device/Elevator',
  'https://w3id.org/rec/device/Escalator',
  'https://w3id.org/rec/device/ExhaustAir',
  'https://w3id.org/rec/device/ExtractAir',
  'https://w3id.org/rec/device/Fan',
  'https://w3id.org/rec/device/Filter',
  'https://w3id.org/rec/device/Fixed_length_string',
  'https://w3id.org/rec/device/Heater',
  'https://w3id.org/rec/device/HeatRecovery',
  'https://w3id.org/rec/device/HotWaterFlow',
  'https://w3id.org/rec/device/HotWaterReturn',
  'https://w3id.org/rec/device/Hwrc',
  'https://w3id.org/rec/device/IndoorAir',
  'https://w3id.org/rec/device/IP',
  'https://w3id.org/rec/device/KNX',
  'https://w3id.org/rec/device/LoRa',
  'https://w3id.org/rec/device/MBus',
  'https://w3id.org/rec/device/ModbusRTU',
  'https://w3id.org/rec/device/ModbusTCP',
  'https://w3id.org/rec/device/OPC-DA',
  'https://w3id.org/rec/device/OPC-UA',
  'https://w3id.org/rec/device/OutdoorAir',
  'https://w3id.org/rec/device/PrimaryCoolingFlow',
  'https://w3id.org/rec/device/PrimaryCoolingReturn',
  'https://w3id.org/rec/device/PrimaryHeatingFlow',
  'https://w3id.org/rec/device/PrimaryHeatingReturn',
  'https://w3id.org/rec/device/Pump',
  'https://w3id.org/rec/device/RecyclingEnergyFlow',
  'https://w3id.org/rec/device/RecyclingEnergyReturn',
  'https://w3id.org/rec/device/SecondaryCoolingFlow',
  'https://w3id.org/rec/device/SecondaryCoolingReturn',
  'https://w3id.org/rec/device/SecondaryHeatingFlow',
  'https://w3id.org/rec/device/SecondaryHeatingReturn',
  'https://w3id.org/rec/device/SteamFlow',
  'https://w3id.org/rec/device/SteamReturn',
  'https://w3id.org/rec/device/SupplyAir',
  'https://w3id.org/rec/device/Thermostat',
  'https://w3id.org/rec/device/Valve',
  'https://w3id.org/rec/device/Variable_length_string',
  'https://w3id.org/rec/device/WasteWater',
  'https://w3id.org/rec/lease/CoffeePremises',
  'https://w3id.org/rec/lease/EducationalPremises',
  'https://w3id.org/rec/lease/GaragePremises',
  'https://w3id.org/rec/lease/HotelPremises',
  'https://w3id.org/rec/lease/LaboratoryPremises',
  'https://w3id.org/rec/lease/LightIndustryPremises',
  'https://w3id.org/rec/lease/OfficePremises',
  'https://w3id.org/rec/lease/ResidentialPremises',
  'https://w3id.org/rec/lease/RestaurantPremises',
  'https://w3id.org/rec/lease/RetailPremises',
  'https://w3id.org/rec/lease/StoragePremises',
]

export { Individuals }
